// State
export const state = () => ({
    notifications: [],
    cancelToken: {},
})

// Actions
export const actions = {
    async getNotifications({ commit, state }, params) {
        if (state?.cancelToken?.getNotifications) {
            state?.cancelToken?.getNotifications.cancel('')
        }
        commit('setCancelTokens', {
            getNotifications: this.$axios.CancelToken.source(),
        })
        const response = await this.$axios
            .get('/notifications', {
                params,
                cancelToken: state.cancelToken.getNotifications.token,
            })
            .then((data) => {
                commit('setNotifications', data.data)
                return data.data
            })
            .catch((_) => {
                return false
            })
        return response
    },
    async deleteNotification({ dispatch }, id) {
        const response = await this.$axios
            .delete(`/notifications/delete/${id}`, {})
            .then((data) => {
                dispatch('getNotifications', {})
                return data.data
            })
            .catch((_) => {
                return false
            })
        return response
    },
    async clearAllNotifications({ dispatch }, id) {
        const response = await this.$axios
            .delete(`/notifications/clear`, {})
            .then((data) => {
                dispatch('getNotifications', {})
                return data.data
            })
            .catch((_) => {
                return false
            })
        return response
    },
    onDeleteNotificationList({ commit, state }, id) {
        const notifications = state.notifications.filter((el) => el._id !== id)
        commit('setNotifications', notifications)
    },
    async onViewNotification({ dispatch }, id) {
        const response = await this.$axios
            .put(`/notifications/view/${id}`, {})
            .then((data) => {
                return data.data
            })
            .catch((_) => {
                return false
            })
        return response
    },
}

// Mutations
export const mutations = {
    setNotifications: (state, data) => {
        state.notifications = data
    },
    setCancelTokens: (state, data) => {
        const oldData = { ...state.cancelToken }
        state.cancelToken = {
            ...oldData,
            ...data,
        }
    },
}
